 import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Typography,
  CircularProgress,
  Box,
} from "@mui/material"; 

 import SelectorComponent from "../orderProcessing/SelectorComponent";
 import { getUserData } from "../../auth";
import { useGetBalanceQuery } from "../../apis/BalanceApi";

export default function OrderDialog({ open, onClose, row }) {

    const userData = getUserData();
    const userId = userData?.uid || "";
  

const { data: balanceData, isLoading:isLoadingBalance, error:errorBalance } = useGetBalanceQuery(userId);
   // console.log('balanceData',balanceData);


    const myBalance = balanceData ? balanceData :
    {
      id: 0,
      balance:0
    } 

   

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="lg" // Ensures the modal is large
    >
      <DialogTitle>Confirm Order Processing</DialogTitle>
      <DialogContent>
        <Typography variant="body1" gutterBottom>
          processing order {row?.cart.totalPrice}
        </Typography>
        <Box sx={{ mt: 2 }}>
          {isLoadingBalance ? (
            <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
              <CircularProgress />
            </Box>
          ) :  errorBalance ? (
            <Typography variant="body1" color="error">
              Error something went wrong in platform please try again.
            </Typography>
          ) : (
            <section className="account py-15">
              <div className="container container-lg">
                <div className="row gy-4">
                   <SelectorComponent
                      balance={myBalance?.balance}
                    order={row} 
                   />
                  
                </div>
              </div>
            </section>
          )}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Cancel
        </Button>
      
      </DialogActions>
    </Dialog>
  );
}
